// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"SuccessOrder_headerWrapper__2T5ij","rateBtn":"SuccessOrder_rateBtn__I_06e"};